module.exports = __webpack_public_path__ + "img/logo-light.a5c43380.png";